import { ProductPromotions } from '@mews-commander/data-access';
import { FlagSelectField } from '@mews-commander/form';
import { lt } from '@mews/framework';

export const PromotionsSelectField = () => (
    <FlagSelectField<ProductPromotions>
        name="promotions"
        label={lt('Promotions')}
        flagName="ProductPromotions"
        flagValues={[
            'afterCheckIn',
            'afterCheckOut',
            'beforeCheckIn',
            'beforeCheckOut',
            'duringCheckOut',
            'duringStay',
        ]}
        multiselect
    />
);
